import React from "react";
import { useI18n } from "../../i18n";
import { formatAmount } from "../utils/money";

/**
 * The register's primary action. Rendered inline in the phone sheet and pinned
 * to the bottom of the ticket column on large screens, so it is always in
 * reach however long the ticket gets.
 */
const CompleteSaleButton = ({
  total,
  currency,
  submitting,
  disabled,
  onClick,
}) => {
  const { t } = useI18n();

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="w-full h-16 rounded-2xl bg-emerald-600 hover:bg-emerald-500 disabled:bg-slate-700 disabled:text-slate-500 text-white font-extrabold text-lg flex items-center justify-between gap-3 px-5 shadow-xl shadow-emerald-600/20 active:scale-[0.99] transition-all"
    >
      <span className="truncate">
        {submitting ? t("pos.payment.saving") : t("pos.payment.complete")}
      </span>
      <span className="tabular-nums shrink-0">
        {formatAmount(total)} {currency}
      </span>
    </button>
  );
};

export default CompleteSaleButton;
